import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';
interface PdfCandidateDetailsProps {
  data: any;
}

const PdfCandidateDetails: React.FC<PdfCandidateDetailsProps> = (props) => {
  const styles = StyleSheet.create({
    image: {
      width: '100%'
    },
    text: {
      fontSize: '9px',
      paddingBottom: '10px'
    },
    leftColumn: {
      flexDirection: 'row',
      width: '100%',
      float: 'left'
    },
    rightColumn: {
      float: 'right',
      justifyContent: 'center'
    },

    row: {
      width: '100%',
      display: 'flex',

      flexDirection: 'row',
      alignContent: 'center'
    },
    bannertext: {
      fontSize: '14px',
      backgroundColor: '#ebf9fb',
      marginBottom: '7px',
      color: '#298d9c',
      padding: '2.5px 2.5px 2.5px 5px',
      fontFamily: 'Libre Franklin Bold',
      borderBottom: '1px solid #288C9C'
    },
    imagePassport: {
      width: '100px',
      height: '100px',
      float: 'right',
      alignContent: 'center'
    },
    container: {
      flexDirection: 'row',
      fontSize: '9px',
      justifyContent: 'flex-start',
      fontFamily: 'Libre Franklin',
      paddingBottom: 7,
      width: '360px'
    },
    label: {
      fontSize: '10px',
      width: '110px',
      fontFamily: 'Libre Franklin Bold'
    },
    labelValue: {
      fontSize: '9px',
      width: '250px'
    }
  });

  return (
    <View>
      <Text style={styles.bannertext}>Candidate Details</Text>
      <View style={{ flexDirection: 'row' }}>
        <View style={{ flex: 1, paddingBottom: 15, paddingLeft: 7 }}>
          <View style={styles.container}>
            <Text style={styles.label}>Last Name:</Text>
            <Text style={styles.labelValue}>{props.data.lastName}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.label}>Rest of Name:</Text>
            <Text style={styles.labelValue}>{props.data.restOfName}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.label}>Generational Suffix:</Text>
            <Text style={styles.labelValue}>{props.data.generationalSuffix}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.label}>Date of Birth:</Text>
            <Text style={styles.labelValue}>
              {props.data.dateOfBirth &&
                (props.data.dateOfBirth as string)
                  .split(' ')
                  .map((part: string, index: number) => (index === 1 ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : part))
                  .join(' ')}
            </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.label}>Gender:</Text>
            <Text style={styles.labelValue}>{props.data.gender}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.label}>CVHP ID:</Text>
            <Text style={styles.labelValue}>{props.data.applicantId}</Text>
          </View>
          {props.data.caseId && (
            <View style={styles.container}>
              <Text style={styles.label}>Case ID:</Text>
              <Text style={styles.labelValue}>{props.data.caseId}</Text>
            </View>
          )}
        </View>
        <View style={styles.rightColumn}>
          <Image style={styles.imagePassport} src={props.data.photo} />
          <Text style={[styles.text, { paddingRight: 10 }]}>Photo provided by candidate.</Text>
        </View>
      </View>
    </View>
  );
};

export default PdfCandidateDetails;
